<div class="flex flex-col items-center text-center">
	<p class="modal-header font-bold">Are you sure you want to clear order?</p>
	<p>All details you've entered for this order will be lost</p>
	<div class="mt-4 flex items-center justify-center gap-3">
		<app-button size="small" btn="secondary" (onClick)="close()">No</app-button>
		<app-button size="small" btn="primary" (onClick)="clear()">Yes</app-button>
	</div>
</div>
